import { useState, useEffect } from 'react';
import { DEVICE_BREAKPOINTS } from '../constants';

export const useWindowSize = () => {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return dimensions;
};

export const useDeviceSize = () => {
  const { width } = useWindowSize();
  return width > DEVICE_BREAKPOINTS.DESKTOP ? 'Desktop' : 'Mobile';
};
